import { Link } from '@inertiajs/react'
import AppLayout from '../../components/AppLayout'

const SEASON_META = {
  '推し旬': { bg: '#c9963f', text: '#fff' },
  '旬':     { bg: '#4a7c59', text: '#fff' },
  '避':     { bg: '#c0463a', text: '#fff' },
  '通常':   { bg: '#e4e4e4', text: '#777' },
}

const ACTION_META = {
  created: { label: '新規登録', bg: '#dcfce7', text: '#166534' },
  updated: { label: '変更',     bg: '#eff6ff', text: '#1d4ed8' },
  deleted: { label: '削除',     bg: '#fee2e2', text: '#991b1b' },
}

const MONTH_LABELS = ['', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']

function StatusChip({ status }) {
  if (!status) return <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>
  const m = SEASON_META[status] || { bg: '#e4e4e4', text: '#555' }
  return (
    <span style={{
      display: 'inline-block', padding: '2px 8px', borderRadius: '4px',
      background: m.bg, color: m.text, fontSize: '11px', fontWeight: 600
    }}>
      {status}
    </span>
  )
}

export default function SeasonalityHistory({ item, versions }) {
  return (
    <AppLayout title={`旬カレンダー変更履歴 — ${item.name}`}>
      <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Link href="/master/product_items" style={{ color: '#4338ca', textDecoration: 'none', fontSize: '13px' }}>
          ← 品目マスタ
        </Link>
        <span style={{ color: '#cbd5e1' }}>/</span>
        <span style={{ fontSize: '13px', color: '#475569' }}>{item.name}</span>
      </div>

      <div style={{ background: 'white', borderRadius: '10px', padding: '16px 20px', marginBottom: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
        <dl style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 16px', fontSize: '12px', margin: 0 }}>
          <dt style={dtStyle}>品目コード</dt><dd style={ddStyle}><code style={{ fontSize: '11px' }}>{item.item_code}</code></dd>
          <dt style={dtStyle}>件数</dt><dd style={ddStyle}>{versions.length} 件</dd>
        </dl>
      </div>

      {versions.length === 0 ? (
        <div style={{ background: 'white', borderRadius: '10px', padding: '32px', textAlign: 'center', color: '#94a3b8', fontSize: '13px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
          変更履歴はありません
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <th style={th}>日時</th>
                <th style={th}>操作</th>
                <th style={th}>年</th>
                <th style={th}>月</th>
                <th style={th}>変更前</th>
                <th style={th}>変更後</th>
                <th style={th}>コメント</th>
                <th style={th}>変更者</th>
              </tr>
            </thead>
            <tbody>
              {versions.map((v, i) => {
                const am = ACTION_META[v.action_type] || { label: v.action_type, bg: '#e4e4e4', text: '#555' }
                return (
                  <tr key={v.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? 'white' : '#fafafa' }}>
                    <td style={td}>{new Date(v.created_at).toLocaleString('ja-JP')}</td>
                    <td style={td}>
                      <span style={{ padding: '2px 7px', borderRadius: '4px', background: am.bg, color: am.text, fontWeight: 600, fontSize: '11px' }}>
                        {am.label}
                      </span>
                    </td>
                    <td style={{ ...td, textAlign: 'center' }}>{v.season_year ?? '—'}</td>
                    <td style={{ ...td, textAlign: 'center' }}>{v.season_month ? MONTH_LABELS[v.season_month] : '—'}</td>
                    <td style={td}><StatusChip status={v.status_before} /></td>
                    <td style={td}><StatusChip status={v.status_after} /></td>
                    <td style={{ ...td, color: '#64748b' }}>{v.comment || '—'}</td>
                    <td style={{ ...td, color: '#64748b' }}>{v.changed_by || '—'}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </AppLayout>
  )
}

const dtStyle = { color: '#94a3b8', fontWeight: 500, whiteSpace: 'nowrap' }
const ddStyle = { color: '#334155', margin: 0 }
const th = { padding: '8px 12px', textAlign: 'left', fontSize: '11px', fontWeight: 600, color: '#64748b', whiteSpace: 'nowrap' }
const td = { padding: '9px 12px', verticalAlign: 'middle' }
